import { useCellCalendarModal } from '../../../lib/hooks/useCellCalendarModal';
import { ModalDateContentCombinedProps } from './types';

const usePresenter = (props: ModalDateContentCombinedProps): ModalDateContentCombinedProps => {
  const { state, handleClick } = props;
  const {
    datepicker,
    datepickerRef,
    onBlur,
    openDatepicker,
  } = useCellCalendarModal(props);

  const onClick = (event?: React.MouseEvent<HTMLDivElement>) => {
    if (state === 'FirstSelect') {
      openDatepicker();
    }
    event?.currentTarget.focus();
    handleClick?.(event);
  };

  return {
    ...props,
    button: {
      icon: {
        asset: 'CalendarFilled',
      },
    },
    datepicker: {
      ...datepicker,
      onSave: async (newDate?: Date) => {
        await datepicker.onSave(newDate, 'FirstSelect');
      },
    },
    datepickerRef,
    handleBlur: onBlur,
    handleClick: onClick,
  };
};

export default usePresenter;
